export const INTERNAL_ADMIN_USER_ROLE_IDS = [2, 3, 4, 5, 6, 7, 8];
export const CLIENT_USER_ROLE_IDS = [3, 4, 5, 6, 7, 8];
export const ADVERTISER_USER_ROLE_IDS = [5, 6, 7, 8];
